import { render, staticRenderFns } from "./repsol-layout.component.html?vue&type=template&id=11b1261e&scoped=true&external"
import script from "./RepsolLayoutComponent.vue?vue&type=script&lang=ts"
export * from "./RepsolLayoutComponent.vue?vue&type=script&lang=ts"
import style0 from "./repsol-layout.component.scss?vue&type=style&index=0&id=11b1261e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b1261e",
  null
  
)

export default component.exports